import React, { FC } from 'react';
import { ConfirmationDialog } from '../ConfirmationDialog';
import { getSecondsFromMin } from '../../utils/time-helper';
import Button from '@mui/material/Button';
import { IdleUserConfirmationProps } from './IdleUserConfirmation.props';
import useCountdown from '../../hooks/useCountdown';

/**
 * Open the warning Dialog when session is timed out
 */
const IdleUserConfirmation: FC<IdleUserConfirmationProps> = ({
  open,
  onClose,
  onDoTimeout,
  waitTimeMinutes,
  timeoutMinutes,
}) => {
  const { counter, setCounter } = useCountdown(
    waitTimeMinutes,
    onDoTimeout,
    open,
  );

  const handleCounter = () => {
    setCounter(getSecondsFromMin(waitTimeMinutes));
    onClose();
  };

  return (
    <ConfirmationDialog
      data-testid="confirmation-dialog"
      open={open}
      handleClose={handleCounter}
      title={`Session Expiration`}
      content={`The application is idle for more than ${timeoutMinutes} minutes. The session is about to expire.`}
      actions={
        <>
          <Button
            data-testid="stay-button"
            variant="contained"
            color="primary"
            onClick={handleCounter}
          >
            Stay ({counter})
          </Button>
        </>
      }
    />
  );
};

export default IdleUserConfirmation;
